export default __webpack_public_path__ + "static/media/watch-cancel.999f1dbe.svg";